import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { IssuerStatus, SuperintendentStatus } from "@ha/data/basic";
import { BaseModalComponent, HaModalService } from "@ha/ui/common";
import { SelectionListItem } from "@ha/ui/forms";
import { Store } from "@ngxs/store";
import { PermitReturnDelegationConfirmationModalComponent } from "../permit-return-delegation-confirmation-modal/permit-return-delegation-confirmation-modal.component";
import { ReturnCurrentUserDelegationCommand } from "../../../subscriptions/models/return-current-user-delegation-command.model";
import { SubscriptionInvitation } from "../../../subscriptions/models/subscription-invitation";
import { SubscriptionsActions } from "../../../subscriptions/states/subscriptions.actions";
import { SubscriptionsSelectors } from "../../../subscriptions/states/subscriptions.selectors";

export interface PermitReturnDelegationConfirmationModalComponentData extends ReturnCurrentUserDelegationCommand {}

@Component({
    selector: "pmt-permit-return-delegation-modal",
    templateUrl: "./permit-return-delegation-modal.component.html",
    styleUrls: ["./permit-return-delegation-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitReturnDelegationModalComponent extends BaseModalComponent {
    public activeSubscriptions: SubscriptionInvitation[] = [];

    public subscriptionOptions: SelectionListItem[] = [];

    public selectedSubscriptionId: number | undefined;

    public returnIssuerDelegation = false;

    public returnSuperintendentDelegation = false;

    public IssuerStatus = IssuerStatus;

    public SuperintendentStatus = SuperintendentStatus;

    constructor(private store: Store, private modalService: HaModalService) {
        super();
    }

    public ngOnInit(): void {
        this.setSubscriptionOptions();
        this.store.dispatch(new SubscriptionsActions.GetActiveAndPendingSubscriptions()).subscribe(() => {
            this.setSubscriptionOptions();
        });
    }

    public close(): void {
        this.closeModal();
    }

    public returnDelegation(): void {
        this.closeModal();
        this.modalService.open(PermitReturnDelegationConfirmationModalComponent, true, <PermitReturnDelegationConfirmationModalComponentData> {
            subscriptionId: this.selectedSubscriptionId,
            returnIssuerDelegation: this.returnIssuerDelegation,
            returnSuperintendentDelegation: this.returnSuperintendentDelegation,
        }, "header");
    }

    public onSubscriptionChange(subscriptionId: number | undefined): void {
        this.selectedSubscriptionId = subscriptionId;
        this.returnIssuerDelegation = false;
        this.returnSuperintendentDelegation = false;
    }

    public get canReturnDelegation(): boolean {
        return this.returnIssuerDelegation || this.returnSuperintendentDelegation;
    }

    public get hasIssuerRole(): boolean {
        return this.selectedSubscription?.issuerStatus === IssuerStatus.active;
    }

    public get hasSuperintendentRole(): boolean {
        return this.selectedSubscription?.superintendentStatus === SuperintendentStatus.active;
    }

    private get selectedSubscription(): SubscriptionInvitation | undefined {
        return this.activeSubscriptions.find((subscription) => subscription.subscriptionId === this.selectedSubscriptionId);
    }

    private setSubscriptionOptions(): void {
        this.activeSubscriptions = this.store.selectSnapshot(SubscriptionsSelectors.returnDelegationSubscriptions) ?? [];

        this.subscriptionOptions = this.activeSubscriptions.map((subscription: SubscriptionInvitation) => <SelectionListItem> {
            value: subscription.subscriptionId,
            text: subscription.subscriptionName,
        });

        this.onSubscriptionChange(this.subscriptionOptions[0]?.value as number | undefined);
    }
}